import RecargoCreate from './RecargoCreate'
export { RecargoCreate }
export default RecargoCreate
